import React from 'react';
import { UserIcon } from 'lucide-react';
export const SocialProofSection = () => {
  const testimonials = ['Over 10,000 Ronaldo fans have already pre-registered interest for this edition.', 'The first batch sold out in under 72 hours in private pre-launch.', 'From Madrid to Manila, collectors are showcasing their sealed Legacy #7 copies with pride.'];
  return <div className="bg-gray-50 py-16" data-id="element-161">
      <div className="container mx-auto px-4" data-id="element-162">
        <h2 className="text-3xl font-bold text-center mb-4" data-id="element-163">Social Proof</h2>
        <p className="text-center mb-12 text-gray-700 max-w-2xl mx-auto" data-id="element-164">
          Collectors around the world rush to secure their place in history:
        </p>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-165">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md" data-id="element-166">
              <div className="flex justify-center mb-4" data-id="element-167">
                <div className="bg-gray-200 rounded-full p-3" data-id="element-168">
                  <UserIcon className="h-6 w-6 text-gray-600" data-id="element-169" />
                </div>
              </div>
              <p className="text-center text-gray-700" data-id="element-170">{testimonial}</p>
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-171">
          <p className="text-lg italic text-gray-700" data-id="element-172">
            This isn't hype — it's history being claimed.
          </p>
        </div>
        <div className="mt-10 flex justify-center" data-id="element-173">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vTfNnAP5Hpi5uycPRUufJi/Generated_Image_September_26%2C_2025_-_4_11PM.png" alt="Cristiano Ronaldo signing books for fans" className="rounded-lg shadow-xl max-w-full md:max-w-lg h-auto" data-id="element-174" />
        </div>
      </div>
    </div>;
};